import { dayJs } from '../day-js';

export function formatDate(date: Date | string, pattern?: string) {
  return dayJs(date).format(pattern);
}

export function formatDateToISO(date: Date = new Date()): string {
  return date.toISOString().split('T')[0];
}
